export class InvoicePaymentTreasuryResponseDto {
  id: number;
  invoiceName: string;
  merchantId: number;
  merchantPaymentMethodId: number;
  createdDate: Date;
  modifiedDate: Date;
  currencyId: number;
  settledAmount: number;
  isRefunded: boolean;
  refundedDate: Date;
  includedRefundInFirebatch: boolean;
  includedInFirebatch: boolean;
  refund: number;
}
